'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.vehicleLookupValidator = undefined;
var _contactDetails = require('@marmalade/validation/lib/bundles/contact-details');
var _vehicleLookup = require('@marmalade/validation/lib/bundles/vehicle-lookup');
var _vehicleLookup2 = _interopRequireDefault(_vehicleLookup);
var _isAlphanumerical = require('@marmalade/validation/lib/is-alphanumerical');
var _isAlphanumerical2 = _interopRequireDefault(_isAlphanumerical);
var _isPostcode = require('@marmalade/validation/lib/is-postcode');
var _isPostcode2 = _interopRequireDefault(_isPostcode);
var _looksLikeEmail = require('@marmalade/validation/lib/looks-like-email');
var _looksLikeEmail2 = _interopRequireDefault(_looksLikeEmail);
var _looksLikePostcode = require('@marmalade/validation/lib/looks-like-postcode');
var _looksLikePostcode2 = _interopRequireDefault(_looksLikePostcode);
var _name = require('@marmalade/validation/lib/name');
var _name2 = _interopRequireDefault(_name);
var _before = require('@marmalade/validation/lib/before');
var _before2 = _interopRequireDefault(_before);
var _oneByOne = require('@marmalade/validation/lib/one-by-one');
var _oneByOne2 = _interopRequireDefault(_oneByOne);
var _oneOf = require('@marmalade/validation/lib/one-of');
var _oneOf2 = _interopRequireDefault(_oneOf);
var _validDate = require('@marmalade/validation/lib/valid-date');
var _validDate2 = _interopRequireDefault(_validDate);
var _validateIf = require('@marmalade/validation/lib/validate-if');
var _validateIf2 = _interopRequireDefault(_validateIf);
var _constants = require('../../constants');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var postcodeMessage = "Sorry we don't recognise your postcode"; /* eslint-disable no-underscore-dangle */

var purchaseDateMessageReg = 'The purchase date cannot be before year of registration';
var purchaseDateMessageManu = 'The purchase date cannot be before year of manufacturer';
var thirdpartyNameMessage = 'Please tell us the details of the 3rd party you wish to grant permission to';
var denyVehicleOwnerPermission = function denyVehicleOwnerPermission(values) {
  return values.vehicleOwnerPermission === 'N';
};
var requireThirdParty = function requireThirdParty(values) {
  return denyVehicleOwnerPermission(values) && values.thirdPartyPermission === 'Y';
};
var vehicleLookupValidator = exports.vehicleLookupValidator = (0, _vehicleLookup2.default)(_constants.vehicleValue.min, _constants.vehicleValue.max);
exports.default = function (keptOvernightOptions, relationOptions) {
  var now = new Date();
  var nextMonth = new Date(now.getFullYear(), now.getMonth() + 1, 1);
  return Object.assign({}, vehicleLookupValidator, {
    vehiclePurchaseDate: (0, _oneByOne2.default)((0, _validDate2.default)(), (0, _before2.default)(nextMonth, function (_) {
      return 'We cannot accept dates in the future';
    }), function (value, values) {
      var regYear = values.__extra.vehicleLookup.vehicle.regDate && values.__extra.vehicleLookup.vehicle.regDate.year;
      var manufacturedFrom = values.__extra.vehicleLookup.vehicle.manufacturedFromYear;
      if (regYear) {
        // make sure not before vehicleLookup.vehicle.regDate.year
        return value[2] >= regYear ? '' : purchaseDateMessageReg;
      }
      // make sure year not before vehicleLookup.vehicle.manufacturedFromYear
      return value[2] >= manufacturedFrom ? '' : purchaseDateMessageManu;
    }),
    mainInsurer: (0, _isAlphanumerical2.default)('Please let us know name of the main insurer for the car'),
    postcodeKeptOvernight: (0, _oneByOne2.default)((0, _looksLikePostcode2.default)(postcodeMessage), (0, _isPostcode2.default)(postcodeMessage)),
    keptOvernight: (0, _oneOf2.default)(keptOvernightOptions.map(function (option) {
      return option.value;
    }), 'Please let us know where the car is kept overnight'),
    ownerRelation: (0, _oneOf2.default)(relationOptions.map(function (option) {
      return option.value;
    }), 'Please could you tell us how the owner is related to you'),
    owner: (0, _name2.default)(function (_ref) {
      var value = _ref.value;
      return value ? 'Please enter a valid name' : "Please let us know the owner's name";
    }),
    vehicleOwnerPermission: (0, _oneOf2.default)(['Y', 'N']),
    thirdPartyPermission: (0, _validateIf2.default)(function (_, values) {
      return denyVehicleOwnerPermission(values);
    }, (0, _oneOf2.default)(['Y', 'N'])),
    thirdPartyName: (0, _validateIf2.default)(function (_, values) {
      return requireThirdParty(values);
    }, (0, _isAlphanumerical2.default)(thirdpartyNameMessage)),
    thirdPartyEmail: (0, _validateIf2.default)(function (_, values) {
      return requireThirdParty(values);
    }, _contactDetails.email)
  });
};